(function (_app, _api) {

    var _settings = {};

    var paymentsHidEl = ['[id$=hidAfterpay]', '[id$=hidOpenpay]', '[id$=hidIPay]', '[id$=hidHumm]', '[id$=hidZipPayAU]', '[id$=hidZipPayNZ]', '[id$=hidLPay]'];

    var _ready = new $.Deferred();

    var getBasketSettings = function() {
        var settings = $('@basket').data('settings') || {};
        return settings;
    };

    $(function () {

        var _basketSettings = getBasketSettings();

        var skip = false;
        _.each(paymentsHidEl, function(el) {
            if ($(el).val()) {
                skip = true;
            }
        });
        if (skip) {
            _settings = _basketSettings;
            _ready.resolve(_settings);
            return;
        }

        var isMobile = !!location.origin.match(/\/\/m\./);
        if (isMobile && _basketSettings.CheckoutViewMobileEnabled === true || _basketSettings.CheckoutViewFullEnabled === true) {
            _api.checkoutView().done(function (data) {
                var s = data.Value || {};
                _settings = $.extend({}, _basketSettings, s);
                _ready.resolve(_settings);
            });
        } else {
            _settings = _basketSettings;
            _ready.resolve(_settings);
        }
    });

    _app.settings = {
        ready: function (cb) {
            if ($.isFunction(cb)) {
                _ready.promise().done(cb);
            } else {
                return _ready.promise();
            }
        },
        get: function(name) {
            if (name) {
                return _settings[name];
            }
            return _settings;
        },
        set: function(name, value) {
            return _settings[name] = value;
        }
    };

})(app, api);